import React from 'react';
import PropTypes from 'prop-types';

import { Popover as MUIPopover } from '@mui/material';

export const Popover = props => <MUIPopover {...props} />;

Popover.propTypes = {
  anchorEl: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  anchorOrigin: PropTypes.object,
  anchorPosition: PropTypes.object,
  anchorReference: PropTypes.oneOf(['anchorEl', 'anchorPosition', 'none']),
  classes: PropTypes.object,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  style: PropTypes.object,
  transformOrigin: PropTypes.object
};

export default Popover;
